const _EXTENSIONS =
  {
    img: {
      extensions: [
        'gif',
        'png',
        'jpg'
      ],
      icon: 'img',
      display: 'Image File',
      instructions: 'Most Image files are natively recognized by your computer.'
    },
    tiff: {
      extensions: [
        'tiff',
        'tif'
      ],
      icon: 'img',
      display: 'TIFF Image',
      instructions: 'To read TIFF images, you need <a href=\'http://www.adobe.com/products/photoshop/\' target=\'_blank\'>Adobe Photoshop</a> or similar.'
    },
    eps: {
      extensions: [
        'eps',
        'ps'
      ],
      icon: 'eps',
      display: 'Postscript File',
      instructions: 'To read Postscript files, you need <a href=\'http://www.adobe.com/products/illustrator/\' target=\'_blank\'>Adobe Illustrator</a> or similar.'
    },
    bmp: {
      extensions: [
        'bmp'
      ],
      icon: 'img',
      display: 'Bitmap Image',
      instructions: 'To read Bitmap images, you need <a href=\'http://www.adobe.com/products/photoshop/\' target=\'_blank\'>Adobe Photoshop</a> or similar.'
    },
    raw: {
      extensions: [
        '3fr',
        'arw',
        'srf',
        'sr2',
        'bay',
        'crw',
        'cr2',
        'cap',
        'iiq',
        'eip',
        'dng',
        'erf',
        'fff',
        'mef',
        'mos',
        'mrw',
        'nef',
        'nrw',
        'orf',
        'ptx',
        'pef',
        'pxn',
        'r3d',
        'raf',
        'raw',
        'rw2',
        'rwz',
        'k25',
        'kdc',
        'dcs',
        'drf',
        'x3f'
      ],
      icon: 'img',
      display: 'RAW Image',
      instructions: 'To read RAW images, you need <a href=\'http://www.adobe.com/products/photoshop/\' target=\'_blank\'>Adobe Photoshop</a> or similar.'
    },
    indd: {
      extensions: [
        'indd'
      ],
      icon: 'indd',
      display: 'InDesign Document',
      instructions: 'To read InDesign documents, you need <a href=\'http://www.adobe.com/products/indesign/\' target=\'_blank\'>Adobe InDesign</a> or similar.'
    },
    psd: {
      extensions: [
        'psd'
      ],
      icon: 'psd',
      display: 'Photoshop File',
      instructions: 'To read Photoshop files, you need <a href=\'http://www.adobe.com/products/photoshop/\' target=\'_blank\'>Adobe Photoshop</a> or similar.'
    },
    ai: {
      extensions: [
        'ai'
      ],
      icon: 'ai',
      display: 'Illustrator File',
      instructions: 'To read Illustrator files, you need <a href=\'http://www.adobe.com/products/illustrator/\' target=\'_blank\'>Adobe Illustrator</a> or similar.'
    },
    indb: {
      extensions: [
        'indb'
      ],
      icon: 'indd',
      display: 'InDesign Book',
      instructions: 'To read InDesign books, you need <a href=\'http://www.adobe.com/products/indesign/\' target=\'_blank\'>Adobe InDesign</a> or similar.'
    },
    ase: {
      extensions: [
        'ase'
      ],
      icon: 'ase',
      display: 'Adobe Swatch File',
      instructions: 'To read Swatch files, you need <a href=\'http://www.adobe.com/products/creativesuite/\' target=\'_blank\'>Adobe Creative Suite</a> or similar.'
    },
    snd: {
      extensions: [
        'mp3',
        'wav'
      ],
      icon: 'snd',
      display: 'Audio File',
      instructions: 'To listen to Audio files, you need Apple QuickTime, Windows Media Player or similar.'
    },
    vid: {
      extensions: [
        'avi',
        'mov',
        'mp4',
        'mpg',
        'mpeg',
        'wmv',
        'flv'
      ],
      icon: 'vid',
      display: 'Movie File',
      instructions: 'To watch Movie files, you need Apple QuickTime, Windows Media Player or similar.'
    },
    fla: {
      extensions: [
        'fla'
      ],
      icon: 'fla',
      display: 'Flash Document',
      instructions: 'To read Flash documents, you need <a href=\'http://get.adobe.com/flashplayer/\' target=\'_blank\'>Adobe Flash player</a>.'
    },
    swf: {
      extensions: [
        'swf'
      ],
      icon: 'swf',
      display: 'Flash Movie',
      instructions: 'To read Flash movies, you need <a href=\'http://get.adobe.com/flashplayer/\' target=\'_blank\'>Adobe Flash player</a>.'
    },
    dcr: {
      extensions: [
        'dcr'
      ],
      icon: 'dcr',
      display: 'Shockwave Movie',
      instructions: 'To read Shockwave movies, you need <a href=\'http://get.adobe.com/flashplayer/\' target=\'_blank\'>Adobe Flash player</a>.'
    },
    ae: {
      extensions: [
        'ae',
        'aep'
      ],
      icon: 'ae',
      display: 'After Effect File',
      instructions: 'To read After Effect files, you need <a href=\'http://www.adobe.com/products/aftereffects/\' target=\'_blank\'>Adobe After Effects</a>.'
    },
    pdf: {
      extensions: [
        'pdf'
      ],
      icon: 'pdf',
      display: 'PDF Document',
      instructions: 'To read PDF documents, You need the free <a href=\'http://get.adobe.com/reader/\' target=\'_blank\'>Adobe Acrobat Reader</a> or similar.'
    },
    doc: {
      extensions: [
        'doc',
        'docx'
      ],
      icon: 'doc',
      display: 'Word Document',
      instructions: 'To read Word documents, you need <a href=\'http://office.microsoft.com/en-us/word/\' target=\'_blank\'>Microsoft Word</a> or similar.'
    },
    xls: {
      extensions: [
        'xls',
        'xlsx'
      ],
      icon: 'xls',
      display: 'Excel Document',
      instructions: 'To read Excel documents, you need <a href=\'http://office.microsoft.com/en-us/excel/\' target=\'_blank\'>Microsoft Excel</a>, or similar.'
    },
    ppt: {
      extensions: [
        'ppt',
        'pptx',
        'pps'
      ],
      icon: 'ppt',
      display: 'Powerpoint Document',
      instructions: 'To read PowerPoint documents, you need <a href=\'http://office.microsoft.com/en-us/powerpoint/\' target=\'_blank\'>Microsoft PowerPoint</a>, or similar.'
    },
    pages: {
      extensions: [
        'pages'
      ],
      icon: 'pages',
      display: 'Pages Document',
      instructions: 'To read Pages documents, you need <a href=\'http://www.apple.com/iwork/pages/\' target=\'_blank\'>Apple iWorks</a>.'
    },
    numbers: {
      extensions: [
        'numbers'
      ],
      icon: 'numbers',
      display: 'Numbers Document',
      instructions: 'To read Numbers documents, you need <a href=\'http://www.apple.com/iwork/numbers/\' target=\'_blank\'>Apple iWorks</a>.'
    },
    key: {
      extensions: [
        'key'
      ],
      icon: 'key',
      display: 'Keynote Document',
      instructions: 'To read Keynote Documents, you need <a href=\'http://www.apple.com/iwork/keynote/\' target=\'_blank\'>Apple iWorks</a>.'
    },
    csv: {
      extensions: [
        'csv'
      ],
      icon: 'sql',
      display: 'CSV File',
      instructions: 'CSV files can be opened with a spreadsheet application such as Microsoft Excel or similar.'
    },
    txt: {
      extensions: [
        'txt'
      ],
      icon: 'txt',
      display: 'Text File',
      instructions: 'To read TXT files, you need any standard text editor.'
    },
    rtf: {
      extensions: [
        'rtf'
      ],
      icon: 'txt',
      display: 'Rich Text File',
      instructions: 'To read RTF files, you need any standard text editor.'
    },
    merlin: {
      extensions: [
        'merlin',
        'merlin2'
      ],
      icon: 'merlin',
      display: 'Merlin File',
      instructions: 'To read Merlin files, you need <a href=\'http://projectwizards.net/\' target=\'_blank\'>Merlin</a>.'
    },
    oplx: {
      extensions: [
        'oplx'
      ],
      icon: 'merlin',
      display: 'OmniPlan File',
      instructions: 'To read OmniPlan files, you need <a href=\'https://www.omnigroup.com/omniplan\' target=\'_blank\'>OmniPlan</a>.'
    },
    zip: {
      extensions: [
        'zip',
        'str',
        'tar',
        'gz'
      ],
      icon: 'zip',
      display: 'Archive',
      instructions: 'Most archive formats are natively recognized by your computer.'
    },
    dmg: {
      extensions: [
        'dmg'
      ],
      icon: 'dmg',
      display: 'DMG Installer',
      instructions: 'DMG installers are disc images for Mac used for the installation of applications.'
    },
    fnt: {
      extensions: [
        'fnt',
        'ttf',
        'bmap',
        'afm',
        'otf'
      ],
      icon: 'fnt',
      display: 'Font',
      instructions: 'To open Font packages, you need a font manager application such as FontCreator on a PC or Font Book on a Mac.'
    },
    suit: {
      extensions: [
        'suit'
      ],
      icon: 'fnt',
      display: 'Font Suitcase',
      instructions: 'To open Font Suitcase, you need a Mac.'
    },
    html: {
      extensions: [
        'htm',
        'html',
        'rhtml'
      ],
      icon: 'html',
      display: 'HTML File',
      instructions: 'To read HTML files, you need a standard text editor.'
    },
    css: {
      extensions: [
        'css'
      ],
      icon: 'gen',
      display: 'Stylesheet',
      instructions: 'To read CSS files, you need a standard text editor.'
    },
    php: {
      extensions: [
        'php'
      ],
      icon: 'gen',
      display: 'PHP File',
      instructions: 'To read PHP files, you need a standard text editor.'
    },
    yml: {
      extensions: [
        'yml'
      ],
      icon: 'sql',
      display: 'YAML File',
      instructions: 'To read YAML files, you need a standard text editor.'
    },
    sql: {
      extensions: [
        'sql'
      ],
      icon: 'sql',
      display: 'MySql Dump',
      instructions: 'To read MySql Dump files, you need <a href=\'http://www.mysql.com/\' target=\'_blank\'>MySQL</a>.'
    },
    dir: {
      extensions: [
        'dir'
      ],
      icon: 'dir',
      display: 'Folder'
    },
    cut: {
      extensions: [
        'cut'
      ],
      icon: 'cut',
      display: 'Shortcut'
    },
    ftr: {
      extensions: [
        'ftr'
      ],
      icon: 'ftr',
      display: 'Feature'
    },
    pop: {
      extensions: [
        'pop'
      ],
      icon: 'pop',
      display: 'Popup Window'
    },
    link: {
      extensions: [
        'net',
        'link',
        'com',
        'fr',
        'net',
        'org',
        'me',
        'us',
        'biz',
        'mobi',
        'info',
        'es',
        'de'
      ],
      icon: 'net',
      display: 'Internet Location'
    },
    site: {
      extensions: [
        'site'
      ],
      icon: 'site',
      display: 'Mini Site'
    },
    slide: {
      extensions: [
        'slide'
      ],
      icon: 'slide',
      display: 'Slideshow'
    },
    rss: {
      extensions: [
        'rss'
      ],
      icon: 'txt',
      display: 'RSS Feed'
    }
  }

export default _EXTENSIONS
